import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { ExhibitionClient } from '@Pass-It-Down/exhibition-client'

const url = process.env.REACT_APP_SERVER_URL
const api = new ExhibitionClient({url})

export const loadStyle = createAsyncThunk('map/loadStyle',
  async (name) => {
    const response = await api.mapStyle().getByName(name)
    const pinImage  = api.mapStyle().getPinImage(name)
    return { response, pinImage }
  })

export const mapSlice = createSlice({
  name: 'map',
  initialState: {
    style: [],
    name: 'default',
    center: {lat: 0, lng: 0},
    zoom: 11
  },
  reducers: {
    setCenter: (state, action) => {
        state.center = action.center
    },
    setZoom: (state, action) => {
      state.zoom = action.zoom
    }
  },
  extraReducers: {
    [loadStyle.pending]: (state, action) => {
    },
    [loadStyle.fulfilled]: (state, action) => {
      state.style = [ ...state.style, ...action.payload.response]
    }
}})


export const setCenter = (center) =>  {
  return {type: 'map/setCenter', center}
}

export const setZoom = (zoom) =>  {
  return {type: 'map/setZoom', zoom}
}

export const selectMapStyle = state => state.map.style
export const selectPinImage = state => state.map.pinImage
export const selectCenter = state => state.map.center
export const selectZoom = state => state.map.zoom

export default mapSlice.reducer
